/* eslint-disable import/prefer-default-export */

/**
 * If true instead of using our controls, video player will fallback to
 * use native html5 player controls.
 */
export const TOUCH_DEVICES_USE_NATIVE_CONTROLS = false;
